import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  DISCOUNT,TIP,
  ADD_SOLD_QUANTITY,
  ADD_SHIPPING,
  REMOVE_DISCOUNT,
  SHOW_CART,
  CLEAR_CART,
  SPECIAL_REQUEST,
  UPDATE_ITEM_SPECIAL_REQUEST
} from "../action-types/cart-actions";
import { WEB_LOGOUT } from '../action-types/session-actions';
import cloneDeep from "lodash/cloneDeep";

let item_contain_tax = false;

let initState = {
  addedItems: [],
  total: 0,
  subTotal: 0,
  tip:0,
  comment :"",
  chargesTitle: "",
  chargeValue: 0,
  total_tax: 0,
  resultDis: 0,
  orderType: null,
  appliedOffer: null,
  orderPlace: null,
  orderRequest: {},
  storeStatus: null,
  storeOffer: null,
  selectedTender: null,
  child_store_id: null,
  offline_invoice_no: null,
  engineDiscount: null,
};



// const calculateTax = (item) => {
// 	let total_tax_amount = 0;
// 	let { tax, total_amount } = item;
// 	let amount = total_amount;
// 	if (tax && tax.length) {
// 		for (let i = 0; i < tax.length; i++) {
// 			let { tax_pct } = tax[i];
// 			let tax_amount = (amount * tax_pct) / 100;
// 			total_tax_amount = total_tax_amount + tax_amount;
// 			tax[i].amount = Number(Math.round(tax_amount + 'e' + 2) + 'e-' + 2);
// 			tax[i].tax_amount = Number(Math.round(tax_amount + 'e' + 2) + 'e-' + 2);
// 			tax[i].taxable_amount = Number(Math.round(amount + 'e' + 2) + 'e-' + 2);

// 		}
// 	}

// 	item.sub_total = Number(Math.round(amount + 'e' + 2) + 'e-' + 2);
// 	item.taxAmount = Number(Math.round(total_tax_amount + 'e' + 2) + 'e-' + 2);
// 	return item;
// };

// const calculateCharges = (subTotal) => {
//   const selectedOrderType = JSON.parse(localStorage.getItem("ORDER_TYPE"));
//   const orderCode = selectedOrderType?.order?.order_code;
//   const store_charges = JSON.parse(localStorage.getItem("CHARGES"));

//   if (!orderCode || !store_charges?.data?.length) return null;

//   const matchingCharges = store_charges.data.filter(
//     (item) =>
//       item.order_types.includes(orderCode) &&
//       subTotal >= item.min_order_amount
//   );

//   if (!matchingCharges.length) return null;

//   const bestMatch = matchingCharges.reduce((prev, curr) =>
//     curr.min_order_amount > prev.min_order_amount ? curr : prev
//   );

//   return bestMatch;
// };

const calculateCharges = (subTotal) => {
  const selectedOrderType = JSON.parse(localStorage.getItem("ORDER_TYPE"));
  const orderCode = selectedOrderType?.order?.order_code;
  const store_charges = JSON.parse(localStorage.getItem("CHARGES"));

  if (!orderCode || !store_charges?.data?.length) return null;

  const matchingCharges = store_charges.data.filter(
    (item) =>
      item.order_types.includes(orderCode) && subTotal >= item.min_order_amount
  );

  if (!matchingCharges.length) return null;

  let bestMatch = matchingCharges.reduce((prev, curr) =>
    curr.min_order_amount > prev.min_order_amount ? curr : prev
  );

  const baseValue = bestMatch.value;

  let totalTaxAmount = 0;

  if (item_contain_tax) {
    let total_tax_percent = 0;
    let amount = baseValue;

    for (let i = 0; i < bestMatch?.charge_tax_ids.length; i++) {
      total_tax_percent += bestMatch?.charge_tax_ids[i].tax_pct;
    }

    let base_amount = amount / (1 + total_tax_percent / 100);

    (bestMatch.charge_tax_ids || []).map((tax) => {
      const taxAmount = (tax.tax_pct / 100) * base_amount;
      totalTaxAmount += taxAmount;
    });
    bestMatch = { ...bestMatch, value: parseFloat(base_amount.toFixed(2)) };
  } else {
    (bestMatch.charge_tax_ids || []).map((tax) => {
      const taxAmount = (tax.tax_pct / 100) * baseValue;
      totalTaxAmount += taxAmount;
    });
  }

  return {
    ...bestMatch,
    total_tax: parseFloat(totalTaxAmount.toFixed(2)),
  };
};

const calculateTax = (item) => {
  let item_tax_data = JSON.parse(localStorage.getItem("STORE_CONFIG"));
  item_contain_tax =
    item_tax_data?.storeConfig?.general_config?.item_price_contains_tax ==
    "Include";

  let total_tax_amount = 0;
  let total_tax_percent = 0; // Variable to accumulate total tax percentage
  let { tax, total_amount, extended_amount } = item;
  let amount = total_amount;
  let ext_amount = extended_amount;

  if (item.is_taxable === false) {
    item.extended_amount = Number(Math.round(ext_amount + "e" + 2) + "e-" + 2);
    item.sub_total = Number(Math.round(amount + "e" + 2) + "e-" + 2);
    item.taxAmount = 0;
    item.tax_percent = 0;
    return item;
  }

  if (tax && tax.length) {
    if (item_contain_tax) {
      // Calculate total tax percent first
      for (let i = 0; i < tax.length; i++) {
        total_tax_percent += tax[i].tax_pct;
      }

      // Derive taxable base amount from tax-included total
      let base_amount = amount / (1 + total_tax_percent / 100);
      let base_ext_amount = ext_amount / (1 + total_tax_percent / 100);

      console.log("base_amount", base_amount, amount);

      for (let i = 0; i < tax.length; i++) {
        let { tax_pct } = tax[i];
        let tax_amount = (base_amount * tax_pct) / 100;
        total_tax_amount += tax_amount;

        tax[i].amount = tax_amount;
        tax[i].tax_amount = tax_amount;
        tax[i].taxable_amount = base_amount;
      }

      amount = base_amount; // Set sub_total to base amount
      ext_amount = base_ext_amount;
    } else {
      for (let i = 0; i < tax.length; i++) {
        let { tax_pct } = tax[i];
        let tax_amount = (amount * tax_pct) / 100;
        total_tax_amount += tax_amount;
        total_tax_percent += tax_pct;

        tax[i].amount = tax_amount;
        tax[i].tax_amount = tax_amount;
        tax[i].taxable_amount = amount;
      }
    }
  }

  item.extended_amount = Number(Math.round(ext_amount + "e" + 2) + "e-" + 2);
  item.sub_total = Number(Math.round(amount + "e" + 2) + "e-" + 2);
  item.taxAmount = total_tax_amount;
  item.tax_percent = total_tax_percent;
  return item;
};

// const calculateTax = (item) => {
//   let total_tax_amount = 0;
//   let total_tax_percent = 0; // Variable to accumulate total tax percentage
//   let { tax, total_amount } = item;
//   let amount = total_amount;

//   if (tax && tax.length) {
//     for (let i = 0; i < tax.length; i++) {
//       let { tax_pct } = tax[i];
//       let tax_amount = (amount * tax_pct) / 100;
//       total_tax_amount += tax_amount;
//       total_tax_percent += tax_pct; // Add each tax percentage to the total

//       tax[i].amount = Number(Math.round(tax_amount + "e" + 2) + "e-" + 2);
//       tax[i].tax_amount = Number(Math.round(tax_amount + "e" + 2) + "e-" + 2);
//       tax[i].taxable_amount = Number(Math.round(amount + "e" + 2) + "e-" + 2);
//     }
//   }

//   item.sub_total = Number(Math.round(amount + "e" + 2) + "e-" + 2);
//   item.taxAmount = Number(Math.round(total_tax_amount + "e" + 2) + "e-" + 2);
//   item.tax_percent = Number(Math.round(total_tax_percent + "e" + 2) + "e-" + 2); // Add total tax percent
//   return item;
// };

// const calculateItemLevelDiscount = (item, value,subTotal) => {


//   const offer_product = JSON.parse(localStorage.getItem("APPLIED_OFFERS"));

//   if(offer_product?.offer_term_product?.length  &&  !offer_product?.offer_term_product?.find((e)=>e.item_id === item.item_variant[0].sku)){
//     return item;

//   }

// console.log("calculateItemLevelDiscount",item);

//   let total_discount = 0;
//   let resultDis = 0;

//   let total_tax_amount = 0;
//   let total_tax_percent = 0; // Variable to accumulate total tax percentage
//   let { tax, total_amount } = item;
//   let amount = 0;

//   total_discount += Number(
//     Math.round(value.discount_type_value + "e" + 2) + "e-" + 2
//   );
//   let disType = value.discount_type_code;

//   if (disType === "2") {
//     resultDis = (parseFloat(total_discount) / 100) * parseFloat(total_amount);

//     amount = total_amount - resultDis;

//     if (tax && tax.length) {
//       for (let i = 0; i < tax.length; i++) {
//         let { tax_pct } = tax[i];
//         let tax_amount = (amount * tax_pct) / 100;
//         total_tax_amount += tax_amount;
//         total_tax_percent += tax_pct; // Add each tax percentage to the total

//         tax[i].amount = Number(Math.round(tax_amount + "e" + 2) + "e-" + 2);
//         tax[i].tax_amount = Number(Math.round(tax_amount + "e" + 2) + "e-" + 2);
//         tax[i].taxable_amount = Number(Math.round(amount + "e" + 2) + "e-" + 2);
//       }
//     }

//     // item.sub_total = Number(Math.round(amount + "e" + 2) + "e-" + 2);
//     item.taxAmount = Number(Math.round(total_tax_amount + "e" + 2) + "e-" + 2);
//     // item.tax_percent = Number(
//     //   Math.round(total_tax_percent + "e" + 2) + "e-" + 2
//     // ); // Add total tax percent
//     item.discount = Number(Math.round(resultDis + "e" + 2) + "e-" + 2);

//     return item;
//   } else {

//     resultDis =  (item?.sub_total/subTotal)* total_discount;
//     amount = total_amount - resultDis;

//     if (tax && tax.length) {
//       for (let i = 0; i < tax.length; i++) {
//         let { tax_pct } = tax[i];
//         let tax_amount = (amount * tax_pct) / 100;
//         total_tax_amount += tax_amount;
//         total_tax_percent += tax_pct; // Add each tax percentage to the total

//         tax[i].amount = Number(Math.round(tax_amount + "e" + 2) + "e-" + 2);
//         tax[i].tax_amount = Number(Math.round(tax_amount + "e" + 2) + "e-" + 2);
//         tax[i].taxable_amount = Number(Math.round(amount + "e" + 2) + "e-" + 2);
//       }
//     }

//     // item.sub_total = Number(Math.round(amount + "e" + 2) + "e-" + 2);
//     item.taxAmount = Number(Math.round(total_tax_amount + "e" + 2) + "e-" + 2);
//     // item.tax_percent = Number(
//     //   Math.round(total_tax_percent + "e" + 2) + "e-" + 2
//     // ); // Add total tax percent
//     item.discount = Number(Math.round(resultDis + "e" + 2) + "e-" + 2);

//     return item;
//   }
//   if (total_amount <= resultDis) {
//     total_amount = 0;
//   } else {
//     total_amount -= resultDis;
//   }

//   return item;
// };


// const calculateItemLevelDiscount = (item, value, subTotal) => {

//   const offer_product = JSON.parse(localStorage.getItem("APPLIED_OFFERS"));
//   const offerTerms = offer_product?.offer_term || [];
//   const offerTermProducts = offer_product?.offer_term_product || [];

//   const itemSKU = item?.item_variant?.[0]?.sku;

//   // Identify all target terms (where discount_type_value != "0")
//   const targetTerms = offerTerms.filter((term) => parseFloat(term.discount_type_value) > 0);

//   // If there are no target terms, apply discount to all items
//   let isItemTarget = true;

//   if (targetTerms.length > 0) {
//     isItemTarget = false;

//     for (const term of targetTerms) {
//       if (term.is_include_items) {
//         // Only include matching items from offer_term_product with same term ID
//         const matched = offerTermProducts.find(
//           (prod) =>
//             prod.item_id === itemSKU &&
//             prod.offer_term_id === term.offer_term_id
//         );
//         if (matched) {
//           isItemTarget = true;
//           value = term; // use this term’s discount value for the item
//           break;
//         }
//       } else {
//         // All items are targets if is_include_items === false
//         isItemTarget = true;
//         value = term;
//         break;
//       }
//     }
//   }

//   // If not a target, don't apply discount but still calculate tax
//   const discountValue = isItemTarget
//     ? parseFloat(value?.discount_type_value || 0)
//     : 0;

//   const disType = value?.discount_type_code;
//   const { tax = [], total_amount = 0, sub_total = 0 } = item;
//   let resultDis = 0;
//   let total_tax_amount = 0;
//   let discountedAmount = total_amount;

//   // Apply discount
//   if (disType === "2") {
//     resultDis = (discountValue / 100) * total_amount;
//     discountedAmount = total_amount - resultDis;
//   } else {
//     resultDis = (sub_total / subTotal) * discountValue;
//     discountedAmount = total_amount - resultDis;
//   }

//   // Recalculate tax on discountedAmount
//   tax.forEach((t) => {
//     const tax_pct = parseFloat(t?.tax_pct || 0);
//     const tax_amount = (discountedAmount * tax_pct) / 100;

//     t.amount = parseFloat(tax_amount.toFixed(2));
//     t.tax_amount = parseFloat(tax_amount.toFixed(2));
//     t.taxable_amount = parseFloat(discountedAmount.toFixed(2));

//     total_tax_amount += tax_amount;
//   });

//   item.discount = parseFloat(resultDis.toFixed(2));
//   item.taxAmount = parseFloat(total_tax_amount.toFixed(2));

//   return item;
// };

const calculateItemLevelDiscount = (item, value, subTotal, totalDiscountAmount, itemDiscountMap = {}) => {
  const offer_product = JSON.parse(localStorage.getItem("APPLIED_OFFERS"));
  const offerTerms = offer_product?.offer_term || [];
  const offerTermProducts = offer_product?.offer_term_product || [];

  const itemSKU = item?.item_variant?.[0]?.sku;

  // Use pre-computed itemDiscountMap when available (dealdist="1" or Buy-N-Get-N with no specific products)
  if (Object.keys(itemDiscountMap).length > 0 && totalDiscountAmount > 0) {
    const { tax = [], total_amount = 0 } = item;
    const mapEntry = itemDiscountMap[String(itemSKU)];
    const pairedQty = mapEntry?.pairedQty || 0;
    const discountPerUnit = mapEntry?.discountPerUnit || 0;

    // paired units get discount, unpaired units stay at full price
    const resultDis = pairedQty * discountPerUnit;
    let discountedAmount = total_amount - resultDis;

    const item_tax_data = JSON.parse(localStorage.getItem("STORE_CONFIG"));
    const item_contain_tax = item_tax_data?.storeConfig?.general_config?.item_price_contains_tax === "Include";
    let total_tax_amount = 0;
    let total_tax_percent = 0;

    if (item.is_taxable === false) {
      item.discount = Number(Math.round(resultDis + "e2") + "e-2");
      item.base_price = Number(Math.round(total_amount + "e2") + "e-2");
      item.sub_total = Number(Math.round(discountedAmount + "e2") + "e-2");
      item.taxAmount = 0;
      item.tax_percent = 0;
      return item;
    }

    if (tax && tax.length) {
      if (item_contain_tax) {
        for (let i = 0; i < tax.length; i++) total_tax_percent += parseFloat(tax[i].tax_pct) || 0;
        const base_total = total_amount / (1 + total_tax_percent / 100);
        let base_amount = discountedAmount / (1 + total_tax_percent / 100);
        for (let i = 0; i < tax.length; i++) {
          let tax_pct = parseFloat(tax[i].tax_pct) || 0;
          let tax_amount = (base_amount * tax_pct) / 100;
          total_tax_amount += tax_amount;
          tax[i].amount = Number(Math.round(tax_amount + "e2") + "e-2");
          tax[i].tax_amount = Number(Math.round(tax_amount + "e2") + "e-2");
          tax[i].taxable_amount = Number(Math.round(base_amount + "e2") + "e-2");
        }
        // Store discount as base (tax-excluded) amount to stay consistent with sub_total
        const base_dis = base_total - base_amount;
        item.discount = Number(Math.round(base_dis + "e2") + "e-2");
        item.base_price = Number(Math.round(base_total + "e2") + "e-2");
        item.sub_total = Number(Math.round(base_amount + "e2") + "e-2");
        item.taxAmount = Number(Math.round(total_tax_amount + "e2") + "e-2");
        item.tax_percent = Number(Math.round(total_tax_percent + "e2") + "e-2");
        return item;
      } else {
        for (let i = 0; i < tax.length; i++) {
          let tax_pct = parseFloat(tax[i].tax_pct) || 0;
          let tax_amount = (discountedAmount * tax_pct) / 100;
          total_tax_amount += tax_amount;
          total_tax_percent += tax_pct;
          tax[i].amount = Number(Math.round(tax_amount + "e2") + "e-2");
          tax[i].tax_amount = Number(Math.round(tax_amount + "e2") + "e-2");
          tax[i].taxable_amount = Number(Math.round(discountedAmount + "e2") + "e-2");
        }
      }
    }

    item.discount = Number(Math.round(resultDis + "e2") + "e-2");
    item.base_price = Number(Math.round(total_amount + "e2") + "e-2");
    item.sub_total = Number(Math.round(discountedAmount + "e2") + "e-2");
    item.taxAmount = Number(Math.round(total_tax_amount + "e2") + "e-2");
    item.tax_percent = Number(Math.round(total_tax_percent + "e2") + "e-2");
    return item;
  }

  // Identify all target terms (where discount_type_value != "0")
  const targetTerms = offerTerms.filter(
    (term) => parseFloat(term.discount_type_value) > 0
  );

  // If there are no target terms, apply discount to all items
  let isItemTarget = true;

  if (targetTerms.length > 0) {
    isItemTarget = false;

    for (const term of targetTerms) {
      if (term.is_include_items) {
        const termProds = offerTermProducts.filter(prod => prod.offer_term_id === term.offer_term_id);
        const isAnyItemIdEmpty = termProds.some(prod => prod.item_id === "");

        if (isAnyItemIdEmpty) {
          // Category-level offer — check if item’s category matches
          const categoryMatch = termProds.some(prod => prod.category_id === item.category_id);
          if (categoryMatch) {
            isItemTarget = true;
            value = term;
            break;
          }
        } else {
          // Item-level offer — check if item’s SKU matches
          const matched = termProds.find(prod => prod.item_id === itemSKU);
          if (matched) {
            isItemTarget = true;
            value = term;
            break;
          }
        }
      } else {
        // All items are targets if is_include_items === false
        isItemTarget = true;
        value = term;
        break;
      }
    }
  }

  // If not a target, don’t apply discount but still calculate tax
  const discountValue = isItemTarget
    ? parseFloat(value?.discount_type_value || 0)
    : 0;

  const disType = value?.discount_type_code;
  const noPerTrans = String(value?.no_pertrans ?? "1");
  let { tax = [], total_amount = 0, sub_total = 0 } = item;
  const plu = parseFloat(item.item_variant[0].plu) || 0;
  let resultDis = 0;

  // Apply discount
  // disType "2" = percentage off item/transaction
  // disType "1"/"3" = flat amount off item
  // no_pertrans="0" → cap discount to 1 unit only regardless of quantity
  if (disType === "2") {
    const effectiveAmount = noPerTrans === "0" ? plu : total_amount;
    resultDis = (discountValue / 100) * effectiveAmount;
  } else if (disType === "1" || disType === "3") {
    const effectiveAmount = noPerTrans === "0" ? plu : total_amount;
    resultDis = Math.min(discountValue, effectiveAmount);
  } else {
    resultDis = subTotal > 0 ? (sub_total / subTotal) * discountValue : 0;
  }

  // Adjust total amounts after discount
  let discountedAmount = total_amount - resultDis;

  if (item.is_taxable === false) {
    item.discount = Number(Math.round(resultDis + "e2") + "e-2");
    item.base_price = Number(Math.round(total_amount + "e2") + "e-2");
    item.sub_total = Number(Math.round(discountedAmount + "e2") + "e-2");
    item.taxAmount = 0;
    item.tax_percent = 0;
    return item;
  }

  // --- TAX CALCULATION (merged from calculateTax) ---
  const item_tax_data = JSON.parse(localStorage.getItem("STORE_CONFIG"));
  const item_contain_tax =
    item_tax_data?.storeConfig?.general_config?.item_price_contains_tax ===
    "Include";

  let total_tax_amount = 0;
  let total_tax_percent = 0;

  if (tax && tax.length) {
    if (item_contain_tax) {
      // Sum tax percent
      for (let i = 0; i < tax.length; i++) {
        total_tax_percent += parseFloat(tax[i].tax_pct) || 0;
      }

      const base_total = total_amount / (1 + total_tax_percent / 100);
      let base_amount = discountedAmount / (1 + total_tax_percent / 100);

      for (let i = 0; i < tax.length; i++) {
        let tax_pct = parseFloat(tax[i].tax_pct) || 0;
        let tax_amount = (base_amount * tax_pct) / 100;
        total_tax_amount += tax_amount;

        tax[i].amount = Number(Math.round(tax_amount + "e2") + "e-2");
        tax[i].tax_amount = Number(Math.round(tax_amount + "e2") + "e-2");
        tax[i].taxable_amount = Number(Math.round(base_amount + "e2") + "e-2");
      }

      // Store discount as base (tax-excluded) to stay consistent with sub_total
      const base_dis = base_total - base_amount;
      item.discount = Number(Math.round(base_dis + "e2") + "e-2");
      item.base_price = Number(Math.round(base_total + "e2") + "e-2");
      item.sub_total = Number(Math.round(base_amount + "e2") + "e-2");
      item.taxAmount = Number(Math.round(total_tax_amount + "e2") + "e-2");
      item.tax_percent = Number(Math.round(total_tax_percent + "e2") + "e-2");
      return item;
    } else {
      for (let i = 0; i < tax.length; i++) {
        let tax_pct = parseFloat(tax[i].tax_pct) || 0;
        let tax_amount = (discountedAmount * tax_pct) / 100;
        total_tax_amount += tax_amount;
        total_tax_percent += tax_pct;

        tax[i].amount = Number(Math.round(tax_amount + "e2") + "e-2");
        tax[i].tax_amount = Number(Math.round(tax_amount + "e2") + "e-2");
        tax[i].taxable_amount = Number(
          Math.round(discountedAmount + "e2") + "e-2"
        );
      }
    }
  }

  // --- FINAL VALUES ON ITEM ---
  item.discount = Number(Math.round(resultDis + "e2") + "e-2");
  item.base_price = Number(Math.round(total_amount + "e2") + "e-2");
  item.sub_total = Number(Math.round(discountedAmount + "e2") + "e-2");
  item.taxAmount = Number(Math.round(total_tax_amount + "e2") + "e-2");
  item.tax_percent = Number(Math.round(total_tax_percent + "e2") + "e-2");

  return item;
};




const calculateDiscount = (total, value, state) => {
  let total_discount = 0;
  let resultDis = 0;
  total_discount += Number(
    Math.round(value.discount_type_value + "e" + 2) + "e-" + 2
  );
  let disType = value.discount_type_code;

  if (disType === "2") {
    resultDis = (parseFloat(total_discount) / 100) * parseFloat(total);
  } else {
    resultDis = total_discount;
  }
  if (total <= resultDis) {
    total = 0;
  } else {
    total -= resultDis;
  }

  let fData = { ...state, resultDis };

  return resultDis;
};

// const calculateDiscount=(item)=>{
//     let Discount_Amount=0;
//     let Total_Discount_Amount=0;
//     let {Discount,quantity,Price}=item;
//     let MRP_Price   =  Price*(quantity);
//     if(Discount && Discount.length){
//         for(let i=0;i<Discount.length;i++){
//             let DicountObj = Discount[i];
//             let {Discount_Type,Amount_to_Trigger,No_of_line_to_trigger} =DicountObj;
//             No_of_line_to_trigger = No_of_line_to_trigger || 0;
//             Amount_to_Trigger = Amount_to_Trigger || 0;
//             console.log("No_of_line_to_trigger=",No_of_line_to_trigger,"Amount_to_Trigger=",Amount_to_Trigger);
//             if([0,1,2].includes(Discount_Type)){
//                 if(Amount_to_Trigger <= MRP_Price && No_of_line_to_trigger <= quantity){
//                     if(Discount_Type ===0){
//                         Discount_Amount = DicountObj['Deal_Price_Value'];
//                     }else if(Discount_Type ===1){
//                         let Discount_perc_Value =DicountObj['Discount_%_Value'];
//                         Discount_Amount = (MRP_Price*Discount_perc_Value)/100;
//                     }else if(Discount_Type ===2){
//                         Discount_Amount = DicountObj["Discount_Amount_Value"];
//                     }
//                 }
//                 //Total_Discount_Amount=Total_Discount_Amount+Discount_Amount;
//             }else if([3].includes(Discount_Type)){
//                 if(Discount_Type ===3){
//                     let No_of_Least_Expensive_Items = DicountObj['No_of_Least_Expensive_Items'];
//                     //********************* */

//                     let buy = No_of_line_to_trigger-No_of_Least_Expensive_Items;
//                     let get = No_of_Least_Expensive_Items

//                     let r = quantity % (buy)
//                     let n = (quantity - r) / (buy)
//                     let free_items_quantity = Math.max(0, r - buy) + (n * get);

//                     //console.log("buy=",buy,"get=",get,"quantity=",quantity,"free=",free_items_quantity);
//                     //********************* */
//                     let line_Mrp_Price = Price*free_items_quantity;
//                     let Discount_perc_Value =DicountObj['Disc_%_of_Least_Expensive'];
//                     Discount_Amount = (line_Mrp_Price*Discount_perc_Value)/100;
//                     item.free_items_quantity =free_items_quantity;

//                 }
//             }else if([4].includes(Discount_Type)){
//                 console.log("Discount 4 need to be applied");
//                 Discount_Amount=(DicountObj.Discount_Amount || 0);
//                 //Total_Discount_Amount=Discount_Amount //+ (item.Discount_Amount || 0);
//             }
//             Total_Discount_Amount=Total_Discount_Amount+Discount_Amount;
//             Discount[i].Discount_Amount=Number(Math.round(Discount_Amount+'e'+2)+'e-'+2);
//         }
//     }
//     item.Discount_Amount=Number(Math.round(Total_Discount_Amount+'e'+2)+'e-'+2);
//     return item;
// }

// Re-points APPLIED_OFFERS to the new cheapest item after cart changes (for no_pertrans="0")
const reEvaluateCheapestDiscount = (addedItems) => {
  const appliedOffer = JSON.parse(localStorage.getItem("APPLIED_OFFERS"));
  if (!appliedOffer || !addedItems?.length) return;

  const term = appliedOffer?.offer_term?.[0];
  if (String(term?.no_pertrans) !== "0" || term?.is_include_items !== true) return;

  const cheapest = addedItems.reduce((min, item) => {
    const price = parseFloat(item.item_variant[0]?.plu || 0);
    return price < parseFloat(min.item_variant[0]?.plu || 0) ? item : min;
  }, addedItems[0]);

  const updatedOffer = {
    ...appliedOffer,
    offer_term_product: [{
      item_id: cheapest?.item_variant[0]?.sku,
      offer_term_id: term?.offer_term_id,
      category_id: cheapest?.category_id,
    }],
  };

};

const calculation = (currentState) => {
  const { value, termStyle } = currentState;
  const addedItems = (currentState.addedItems || []).filter(i => !i.is_void && !i.isVoid && !i.is_refund);
  const offeringType = value?.[0]?.offering_type;
  let total = 0;
  let subTotal = 0;
  let originalSubTotal = 0;
  let resultDis = 0;
  let total_tax_item = 0;
  let total_item = 0;
  const taxBifurcation = {}; // tax_dsc -> amount

  // Pre-compute pair-based discount map for dealdist="1" C3 offers
  const offer_product = JSON.parse(localStorage.getItem("APPLIED_OFFERS"));
  const dealdist = offer_product?.offer_header?.dealdist;
  let totalDiscountAmount = 0;
  let cartSubTotalForDist = 0;
  const itemDiscountMap = {}; // SKU -> { pairedQty, discountPerUnit }
  let c3NoProductPrePass = false; // true when Buy-N-Get-N pre-pass ran; skip old logic if map is empty
  let c1FlatPrePass = false; // true when C1 price-to (disType="4") pre-pass ran

  // Pre-compute discount map for C1/C2 flat/pct item-level offers with no_pertrans="0" — discount 1 unit only (cheapest qualifying)
  if (value?.length && (termStyle === "C1" || termStyle === "C2") && ["1","2","3"].includes(value[0]?.discount_type_code) && offeringType !== "Transaction" && String(value[0]?.no_pertrans ?? "1") === "0") {
    const term = value[0];
    const offerTermProducts = offer_product?.offer_term_product || [];
    const discountValue = parseFloat(term.discount_type_value || 0);
    const disType = term.discount_type_code;

    const qualifyingUnits = [];
    for (const item of addedItems) {
      const sku = String(item.item_variant[0].sku);
      const plu = parseFloat(item.item_variant[0].plu) || 0;

      let qualifies = false;
      if (!term.is_include_items) {
        qualifies = true;
      } else {
        const termProducts = offerTermProducts.filter(p => p.offer_term_id === term.offer_term_id);
        const isAnyItemIdEmpty = termProducts.some(p => p.item_id === "");
        if (isAnyItemIdEmpty) {
          qualifies = termProducts.some(p => p.category_id === item.category_id);
        } else {
          qualifies = termProducts.some(p => p.item_id === sku);
        }
      }

      if (qualifies) {
        for (let u = 0; u < item.quantity; u++) {
          qualifyingUnits.push({ sku, plu });
        }
      }
    }

    // Sort cheapest first, apply discount to only 1 unit
    qualifyingUnits.sort((a, b) => a.plu - b.plu);
    const unitToDiscount = qualifyingUnits[0];
    if (unitToDiscount) {
      const dis = disType === "2"
        ? (discountValue / 100) * unitToDiscount.plu
        : Math.min(discountValue, unitToDiscount.plu);
      itemDiscountMap[unitToDiscount.sku] = { pairedQty: 1, discountPerUnit: dis };
      totalDiscountAmount = dis;
    }
    c1FlatPrePass = true;
  }

  // Pre-compute discount map for C1 price-to offers (disType="4") — cheapest qualifying items priced at target
  if (value?.length && (termStyle === "C1" || termStyle === "C2") && value[0]?.discount_type_code === "4" && offeringType !== "Transaction") {
    const term = value[0];
    const offerTermProducts = offer_product?.offer_term_product || [];
    const targetPrice = parseFloat(term.discount_type_value || 0);
    const noPerTrans = String(term.no_pertrans ?? "1");

    // Build list of qualifying units (matching SKU/category if is_include_items=true)
    const qualifyingUnits = [];
    for (const item of addedItems) {
      const sku = String(item.item_variant[0].sku);
      const plu = parseFloat(item.item_variant[0].plu) || 0;
      if (plu <= targetPrice) continue; // already at or below target price, no discount needed

      let qualifies = false;
      if (!term.is_include_items) {
        qualifies = true;
      } else {
        const termProducts = offerTermProducts.filter(p => p.offer_term_id === term.offer_term_id);
        const isAnyItemIdEmpty = termProducts.some(p => p.item_id === "");
        if (isAnyItemIdEmpty) {
          // category-level — check category match
          qualifies = termProducts.some(p => p.category_id === item.category_id);
        } else {
          qualifies = termProducts.some(p => p.item_id === sku);
        }
      }

      if (qualifies) {
        for (let u = 0; u < item.quantity; u++) {
          qualifyingUnits.push({ sku, plu });
        }
      }
    }

    // Sort cheapest first
    qualifyingUnits.sort((a, b) => a.plu - b.plu);

    // no_pertrans="0" → only cheapest 1 unit; "1" → all qualifying units
    const unitsToDiscount = noPerTrans === "0" ? qualifyingUnits.slice(0, 1) : qualifyingUnits;

    for (const unit of unitsToDiscount) {
      const dis = unit.plu - targetPrice;
      if (!itemDiscountMap[unit.sku]) {
        itemDiscountMap[unit.sku] = { pairedQty: 0, discountPerUnit: dis };
      }
      itemDiscountMap[unit.sku].pairedQty += 1;
      totalDiscountAmount += dis;
    }
    c1FlatPrePass = true;
  }

  // Pre-compute discount map for C3 offers with no specific products (Buy N Get N free on cheapest)
  // Also handles dealdist="1" when no offer_term_product entries exist
  if (value?.length && termStyle === "C3" && (dealdist !== "1" || (offer_product?.offer_term_product || []).length === 0)) {
    const offerTerms = offer_product?.offer_term || [];
    const offerTermProducts = offer_product?.offer_term_product || [];
    const getTerm = offerTerms.find(t => parseFloat(t.discount_type_value) > 0 && t.offering_type !== "Transaction");
    const buyTerm = offerTerms.find(t => parseFloat(t.discount_type_value) === 0 && t.offering_type !== "Transaction");

    // Only applies when no specific products are listed (offer applies to any item)
    if (getTerm && buyTerm && offerTermProducts.length === 0) {
      c3NoProductPrePass = true;
      const noPerTrans = String(getTerm?.no_pertrans ?? "1");
      const buyCount = parseInt(buyTerm?.count ?? 1);
      const getCount = parseInt(getTerm?.count ?? 1);
      const discountValue = parseFloat(getTerm.discount_type_value || 0);
      const disType = getTerm.discount_type_code;

      // Expand items to individual units sorted cheapest first (use per-unit display price)
      const allUnits = [];
      for (const item of addedItems) {
        const plu = parseFloat(item.item_variant[0].plu) || 0;
        let itemTotal = plu * item.quantity;
        if (item.selected_addons_items?.length) {
          for (const addon of item.selected_addons_items) {
            itemTotal += parseFloat(addon.item_variant[0].plu) * item.quantity;
          }
        }
        const perUnit = itemTotal / item.quantity;
        for (let u = 0; u < item.quantity; u++) {
          allUnits.push({ sku: String(item.item_variant[0].sku), plu: perUnit });
        }
      }
      allUnits.sort((a, b) => a.plu - b.plu);

      // pairSize = buyCount + getCount: need this many items to form one qualifying pair
      const pairSize = buyCount + getCount;
      const possiblePairs = Math.floor(allUnits.length / pairSize);
      const maxPairs = noPerTrans === "0" ? Math.min(1, possiblePairs) : possiblePairs;

      // For each pair: the cheapest `getCount` units get the discount
      for (let p = 0; p < maxPairs; p++) {
        const pairUnits = allUnits.slice(p * pairSize, (p + 1) * pairSize);
        const discountedUnits = pairUnits.slice(0, getCount);
        for (const unit of discountedUnits) {
          const dis = (disType === "2" || disType === "3")
            ? (discountValue / 100) * unit.plu
            : disType === "4"
              ? Math.max(0, unit.plu - discountValue)
              : discountValue;
          if (!itemDiscountMap[unit.sku]) {
            itemDiscountMap[unit.sku] = { pairedQty: 0, discountPerUnit: dis };
          }
          itemDiscountMap[unit.sku].pairedQty += 1;
          totalDiscountAmount += dis;
        }
      }
    }
  }

  // Pre-compute discount map for C3 offers with specific products (Buy item A, Get item B discounted)
  let c3ProductPrePass = false;
  if (value?.length && termStyle === "C3" && dealdist !== "1") {
    const offerTerms = offer_product?.offer_term || [];
    const offerTermProducts = offer_product?.offer_term_product || [];
    const getTerm = offerTerms.find(t => parseFloat(t.discount_type_value) > 0 && t.offering_type !== "Transaction");
    const buyTerm = offerTerms.find(t => parseFloat(t.discount_type_value) === 0 && t.offering_type !== "Transaction");

    if (getTerm && buyTerm && offerTermProducts.length > 0) {
      c3ProductPrePass = true;
      const noPerTrans = String(getTerm?.no_pertrans ?? "1");
      const buyCount = parseInt(buyTerm?.count ?? 1);
      const getCount = parseInt(getTerm?.count ?? 1);
      const buyProds = offerTermProducts.filter(p => p.offer_term_id === buyTerm.offer_term_id);
      const getProds = offerTermProducts.filter(p => p.offer_term_id === getTerm.offer_term_id);
      const buyItemIdEmpty = buyProds.some(p => p.item_id === "");
      const getItemIdEmpty = getProds.some(p => p.item_id === "");
      const buySKUs = buyProds.map(p => String(p.item_id));
      const getSKUs = getProds.map(p => String(p.item_id));
      const buyCategoryIds = buyProds.map(p => p.category_id);
      const getCategoryIds = getProds.map(p => p.category_id);

      const buyItems = addedItems.filter(i =>
        buyItemIdEmpty
          ? buyCategoryIds.includes(i.category_id)
          : buySKUs.includes(String(i.item_variant[0].sku))
      );
      const getItems = addedItems
        .filter(i =>
          getItemIdEmpty
            ? getCategoryIds.includes(i.category_id)
            : getSKUs.includes(String(i.item_variant[0].sku))
        )
        .slice()
        .sort((a, b) => {
          const priceA = parseFloat(a?.item_variant?.[0]?.plu || 0);
          const priceB = parseFloat(b?.item_variant?.[0]?.plu || 0);
          return priceA - priceB;
        });

      const totalBuyQty = buyItems.reduce((sum, i) => sum + i.quantity, 0);
      const totalGetQty = getItems.reduce((sum, i) => sum + i.quantity, 0);

      // Need at least buyCount BUY items and getCount GET items to form a valid pair
      const possiblePairs = Math.floor(Math.min(totalBuyQty / buyCount, totalGetQty / getCount));
      const maxPairs = noPerTrans === "0" ? Math.min(1, possiblePairs) : possiblePairs;

      if (maxPairs > 0) {
        const discountValue = parseFloat(getTerm.discount_type_value || 0);
        const disType = getTerm.discount_type_code;
        let remainingPairs = maxPairs * getCount;

        for (const getItem of getItems) {
          if (remainingPairs <= 0) break;
          const getPlu = parseFloat(getItem.item_variant[0].plu) || 0;
          const pairedQty = Math.min(getItem.quantity, remainingPairs);
          const dis = (disType === "2" || disType === "3")
            ? (discountValue / 100) * getPlu
            : disType === "4"
              ? Math.max(0, getPlu - discountValue)
              : discountValue;
          itemDiscountMap[String(getItem.item_variant[0].sku)] = { pairedQty, discountPerUnit: dis };
          totalDiscountAmount += dis * pairedQty;
          remainingPairs -= pairedQty;
        }
      }
    }
  }

  if (value?.length && termStyle === "C3" && dealdist === "1" && (offer_product?.offer_term_product || []).length > 0) {
    const offerTerms = offer_product?.offer_term || [];
    const offerTermProducts = offer_product?.offer_term_product || [];

    const buyTerm = offerTerms.find(t => parseFloat(t.discount_type_value) === 0 && t.offering_type !== "Transaction");
    const getTerm = offerTerms.find(t => parseFloat(t.discount_type_value) > 0 && t.offering_type !== "Transaction");

    if (buyTerm && getTerm) {
      const noPerTrans = String(getTerm?.no_pertrans ?? "1");
      const buyProds = offerTermProducts.filter(p => p.offer_term_id === buyTerm.offer_term_id);
      const getProds = offerTermProducts.filter(p => p.offer_term_id === getTerm.offer_term_id);
      const buyItemIdEmpty = buyProds.some(p => p.item_id === "");
      const getItemIdEmpty = getProds.some(p => p.item_id === "");
      const buySKUs = buyProds.map(p => String(p.item_id));
      const getSKUs = getProds.map(p => String(p.item_id));
      const buyCategoryIds = buyProds.map(p => p.category_id);
      const getCategoryIds = getProds.map(p => p.category_id);

      const buyItem = addedItems.find(i =>
        buyItemIdEmpty
          ? buyCategoryIds.includes(i.category_id)
          : buySKUs.includes(String(i.item_variant[0].sku))
      );
      const getItemCandidates = addedItems
        .filter(i =>
          getItemIdEmpty
            ? getCategoryIds.includes(i.category_id)
            : getSKUs.includes(String(i.item_variant[0].sku))
        )
        .slice()
        .sort((a, b) => {
          const priceA = parseFloat(a?.item_variant?.[0]?.plu || 0);
          const priceB = parseFloat(b?.item_variant?.[0]?.plu || 0);
          return priceA - priceB;
        });
      const getItem = getItemCandidates[0];

      const buyQty = buyItem?.quantity || 0;
      const getQty = getItem?.quantity || 0;
      const pairs = noPerTrans === "0" ? 1 : Math.min(buyQty, getQty);

      if (pairs > 0 && buyItem && getItem) {
        const getPlu = parseFloat(getItem.item_variant[0].plu);

        const discountValue = parseFloat(getTerm.discount_type_value || 0);
        const disType = getTerm.discount_type_code;
        const discountPerPair = (disType === "2" || disType === "3")
          ? (discountValue / 100) * getPlu
          : discountValue;

        // Only the GET item receives the discount — BUY item stays at full price
        itemDiscountMap[String(getItem.item_variant[0].sku)] = {
          pairedQty: pairs,
          discountPerUnit: discountPerPair,
        };

        totalDiscountAmount = discountPerPair * pairs;
      }
    }

    for (const item of addedItems) {
      cartSubTotalForDist += item.item_variant[0].plu * item.quantity;
    }
  }

  for (let i = 0; i < addedItems.length; i++) {
    let itemObj = addedItems[i];
    if (itemObj.is_void || itemObj.isVoid || itemObj.is_refund) continue;
    const plu = itemObj.item_variant[0].plu;
    const quantity = itemObj.quantity;
    let total_amount = plu * quantity;
    let extended_amount = plu;

    if (itemObj?.selected_addons_items?.length) {
      const selected_addons_items = itemObj.selected_addons_items;
      for (let k = 0; k < selected_addons_items?.length; k++) {
        const addon = selected_addons_items[k];
        total_amount += addon?.item_variant[0]?.plu * quantity;
      }
    }

    itemObj.extended_amount = extended_amount;
    itemObj.total_amount = total_amount;

    // calculateTax(itemObj);

  if (value?.length && (termStyle === "C3" || c1FlatPrePass || (offeringType !== "Transaction" && termStyle !== "C2"))) {
      // If a pre-pass ran but no items qualified, skip discount entirely
      if ((c3NoProductPrePass || c3ProductPrePass || c1FlatPrePass) && Object.keys(itemDiscountMap).length === 0) {
        itemObj.discount = 0;
        calculateTax(itemObj);
      } else {
        calculateItemLevelDiscount(itemObj, value, dealdist === "1" ? cartSubTotalForDist : subTotal, totalDiscountAmount, itemDiscountMap);
      }
      resultDis += Number(Math.round(itemObj?.discount + "e" + 2) + "e-" + 2);
      total_tax_item += itemObj?.taxAmount || 0;
      total_item += itemObj?.sub_total || 0;

  } else{
    itemObj.discount = 0;
    calculateTax(itemObj);
      total_tax_item += itemObj?.taxAmount || 0;
      total_item += itemObj?.sub_total || 0;
  }


    // itemObj.total_discount = 0;

    itemObj.total_gross_sale = total_amount + (itemObj?.total_item_tax || 0);
    itemObj.total_net_sale = Number(Math.round((total_amount - (itemObj?.discount || 0)) + "e" + 2) + "e-" + 2);

    subTotal += Number(Math.round(itemObj?.sub_total + "e" + 2) + "e-" + 2);
    originalSubTotal += Number(Math.round((itemObj?.base_price ?? itemObj?.sub_total) + "e" + 2) + "e-" + 2);
    (itemObj?.tax || []).forEach(t => {
      if (t.tax_dsc) {
        taxBifurcation[t.tax_dsc] = (taxBifurcation[t.tax_dsc] || 0) + (t.tax_amount || t.amount || 0);
      }
    });
    total += Number(Math.round(itemObj?.sub_total + "e" + 2) + "e-" + 2);

    //total_discount += Number(Math.round(itemObj.Discount_Amount+'e'+2)+'e-'+2);
  }

  // value  &&  (resultDis =calculateItemLevelDiscount(itemObj,value)) // calculate discount if apply

  // if (value?.length) {
  //   for (let i = 0; i < addedItems.length; i++) {
  //     let itemObj = addedItems[i];

  //     const plu = itemObj.item_variant[0].plu;
  //     const quantity = itemObj.quantity;
  //     let total_amount = plu * quantity;
  //     let discount = 0;
  //     if (itemObj?.selected_addons_items?.length) {
  //       const selected_addons_items = itemObj.selected_addons_items;
  //       for (let k = 0; k < selected_addons_items?.length; k++) {
  //         const addon = selected_addons_items[k];
  //         total_amount += addon?.item_variant[0]?.plu;
  //       }
  //     }
  //     calculateItemLevelDiscount(itemObj, value,subTotal);
  //     resultDis += Number(Math.round(itemObj?.discount + "e" + 2) + "e-" + 2);
  //     total_tax_item += Number(Math.round(itemObj?.taxAmount + "e" + 2) + "e-" + 2);
  //     total_item += Number(Math.round(itemObj?.total_amount + "e" + 2) + "e-" + 2);
  //   }
  // }

  currentState.subTotal = subTotal;

  if (value?.length && offeringType === "Transaction" && termStyle !== "C3") {
    resultDis = calculateDiscount(total_item, value[0], currentState);
  }

  console.log("total", total, "resultDis", resultDis);

  const baseTotal = parseFloat((total_item ?? 0).toFixed(2));
  const isTransactionDiscount = value?.length && offeringType === "Transaction" && termStyle !== "C3";
  const discountedBase = baseTotal - (isTransactionDiscount ? resultDis : 0);
  currentState.total = parseFloat(discountedBase.toFixed(2));

  // For transaction-level discount, recalculate tax proportionally on discounted amount
  let adjusted_tax_item = total_tax_item;
  if (isTransactionDiscount && baseTotal > 0) {
    adjusted_tax_item = parseFloat(((total_tax_item * discountedBase) / baseTotal).toFixed(2));
  }


  // currentState.total_tax = Number(
  //   (parseFloat(charges_tax ?? 0) + extraTax).toFixed(2)
  // );


  currentState.total_tax = Number(adjusted_tax_item.toFixed(2));



  currentState.originalSubTotal = parseFloat(originalSubTotal.toFixed(2));
  currentState.taxBifurcation = Object.fromEntries(
    Object.entries(taxBifurcation).map(([k, v]) => [k, parseFloat(v.toFixed(2))])
  );
  currentState.resultDis = resultDis;
  const childStoreItem = (currentState.addedItems || []).find(i => i.store_id);
  currentState.child_store_id = childStoreItem ? childStoreItem.store_id : null;
  return currentState;
};

const getItemUniqueId = (action) => {
  let itemSku = [];
  let { item } = action;
  if (item?.item_variant?.length) {
    itemSku.push(item.item_variant[0].sku);
  }
  if (item?.selected_addons_items?.length) {
    const sku = item?.selected_addons_items.map((e) => e.sku);
    itemSku = [...itemSku, ...sku];
  }
  let id = itemSku.sort().join("");

  if (item?.specialRequest) {
    id += item.specialRequest;
  }

  return id;
};

const countCartItem = (state) => {
  let count = 0;
  state.addedItems.forEach((cartItemDetail) => {
    count +=
      cartItemDetail.soldQuantity &&
      cartItemDetail.quantity === cartItemDetail.soldQuantity
        ? 0
        : 1;
  });
  state.countCartItem = count;
  return state;
};

const cartReducer = (state = initState, _action) => {
  //INSIDE HOME COMPONENT

  let action = cloneDeep(_action);
  // let action = JSON.parse(JSON.stringify(_action))

  const itemUniqueId = getItemUniqueId(action);

  if (action.type === ADD_TO_CART) {
    let { item, quantity } = action;
    // let { _id: itemId } = item.item_variant[0];
    //check if the action id exists in the addedItems
    let existed_item = state.addedItems.find(
      (item) => item.itemUniqueId === itemUniqueId
    );

    if (existed_item) {
      let updatedItems = state.addedItems.map((i) => {
        if (i.itemUniqueId === itemUniqueId) {
          return { ...i, quantity: i.quantity + quantity };
        }
        return i;
      });
      state = { ...state, addedItems: updatedItems };
    } else {
      item.itemUniqueId = itemUniqueId;
      item.quantity = quantity;
      state = { ...state, addedItems: [...state.addedItems, item] };
    }
    state = calculation(state, false);
    state = countCartItem(state);
    return { ...state };
  }

  if (action.type === REMOVE_ITEM) {
    let updatedItems = state.addedItems.filter(
      (item) => item.itemUniqueId !== itemUniqueId
    );

    state = { ...state, addedItems: updatedItems };
    if (state.addedItems.length === 0) {
      delete state.value;
      state.resultDis = 0;
      state.engineDiscount = null;
      state.appliedOffer = null;
      localStorage.removeItem("APPLIED_OFFERS");
    } else {
      reEvaluateCheapestDiscount(state.addedItems);
    }
    state = calculation(state, false);
    state = countCartItem(state);
    return { ...state };
  }

  if (action.type === ADD_QUANTITY) {
    let updatedItems = state.addedItems.map((item) => {
      if (item.itemUniqueId === itemUniqueId) {
        return { ...item, quantity: item.quantity + 1 };
      }
      return item;
    });

    state = { ...state, addedItems: updatedItems };
    state = calculation(state, false);
    state = countCartItem(state);
    return { ...state };
  }

  if (action.type === SUB_QUANTITY) {
    let updatedItems = [];
    state.addedItems.forEach((item) => {
      if (item.itemUniqueId === itemUniqueId) {
        if (item.quantity > 1) {
          updatedItems.push({ ...item, quantity: item.quantity - 1 });
        }
      } else {
        updatedItems.push(item);
      }
    });

    state = { ...state, addedItems: updatedItems };
    if (state.addedItems.length === 0) {
      delete state.value;
      state.resultDis = 0;
      state.engineDiscount = null;
      state.appliedOffer = null;
      localStorage.removeItem("APPLIED_OFFERS");
    } else {
      reEvaluateCheapestDiscount(state.addedItems);
    }
    state = calculation(state, false);
    state = countCartItem(state);
    return { ...state };
  }

  // if (action.type === SUB_QUANTITY) {

  //   let addedItem = state.addedItems.find(
  //     (item) => item.itemUniqueId === itemUniqueId
  //   );
  //   addedItem.quantity -= 1;
  //   if (addedItem.quantity === 0) {
  //     state.addedItems = state.addedItems.filter(
  //       (item) => item.itemUniqueId !== action.item.itemUniqueId
  //     );
  //   }
  //   state = calculation(state, false);
  //   state = countCartItem(state);
  //   let fData = { ...state };
  //   
  //   return fData;
  // }

  if (action.type === REMOVE_DISCOUNT) {
    delete state.value;
    delete state.termStyle;
    localStorage.removeItem("APPLIED_OFFERS");
    state = calculation(state, false);
    state = countCartItem(state);
    let fData = { ...state, resultDis: 0 };

    return fData;
  }

  if (action.type === SPECIAL_REQUEST) {
    let { splReq } = action;

    let comment = "";
    comment = splReq;
    let fData = { ...state, comment, specialRequestText: splReq };

    console.log(fData);
    return fData;
  }

  if (action.type === 'SET_ORDER_TYPE') {
    let fData = { ...state, orderType: action.orderType };
    return fData;
  }

  if (action.type === 'UPDATE_CART_ITEM_PRICES') {
    const updatedAddedItems = action.items || state.addedItems;
    let fData = { ...state, addedItems: updatedAddedItems };
    fData = calculation(fData, false);
    fData = countCartItem(fData);
    return fData;
  }

  if (action.type === UPDATE_ITEM_SPECIAL_REQUEST) {
    const { itemUniqueId, specialRequest } = action;
    let addedItem = state.addedItems.find(
      (item) => item.itemUniqueId === itemUniqueId
    );
    if (addedItem) {
      const oldQty = addedItem.quantity;
      const dummyAction = { item: { ...addedItem, specialRequest } };
      const newItemUniqueId = getItemUniqueId(dummyAction);

      if (newItemUniqueId !== itemUniqueId) {
        let existingItem = state.addedItems.find(
          (item) => item.itemUniqueId === newItemUniqueId
        );
        if (existingItem) {
          existingItem.quantity += oldQty;
          state.addedItems = state.addedItems.filter(
            (item) => item.itemUniqueId !== itemUniqueId
          );
        } else {
          addedItem.specialRequest = specialRequest;
          addedItem.itemUniqueId = newItemUniqueId;
        }
      } else {
        addedItem.specialRequest = specialRequest;
      }

      state = calculation(state, false);
      state = countCartItem(state);
      let fData = { ...state };

      return fData;
    }
    return state;
  }


  if (action.type === TIP) {

    let { tip } = action;
    let data = { ...state, tip };
    state = calculation(data);
    let fData = { ...state, tip: state?.tip };
    console.log(fData)


    return fData;
  }

  if (action.type === DISCOUNT) {
    let { value, termStyle } = action;
    console.log("DISCOUNT action — termStyle:", termStyle, "value (offer_term):", JSON.stringify(value));
    state = { ...state, termStyle };
    let data = { ...state, value, termStyle };
    state = calculation(data);
    let fData = { ...state, resultDis: state?.resultDis };


    return fData;

    // let { value } = action;
    // let total_discount = 0;
    // let resultDis = 0;
    // total_discount += Number(
    // 	Math.round(value.discount_type_value + 'e' + 2) + 'e-' + 2
    // );
    // let disType = value.discount_type_code;

    // if (disType === "2") {
    // 	resultDis = (parseFloat(total_discount) / 100) * parseFloat(state.total);
    // } else {
    // 	resultDis = total_discount;
    // }
    // if (state.total <= resultDis) {
    // 	state.total = 0;
    // } else {
    // 	state.total -= resultDis;
    // }

    // // console.log(state.total);
    // // state= calculation(state,false);
    // let fData = { ...state, resultDis };
    // 
    // console.log(fData);
    // return fData;
  }

  if (action.type === ADD_SOLD_QUANTITY) {
    let { item } = action;
    let { _id: itemId } = item;
    let addedItem = state.addedItems.find((item) => itemId === item._id);
    addedItem.isServed = true;
    addedItem.soldQuantity = addedItem.quantity;
    state = calculation(state, false);
    state = countCartItem(state);
    let fData = { ...state };

    return fData;
  }

  if (action.type === ADD_SHIPPING) {
    let fData = {
      ...state,
      total: state.total + 6,
    };

    return fData;
  }

  if (action.type === 'ORDER_PLACE') {
    return { ...state, orderPlace: action.orderPlace };
  }

  if (action.type === 'SET_TENDER') {
    return { ...state, selectedTender: action.selectedTender };
  }

  if (action.type === 'SET_OFFLINE_INVOICE_NO') {
    return { ...state, offline_invoice_no: action.offline_invoice_no };
  }

  if (action.type === 'CLEAR_ORDER_DETAILS') {
    return { ...state, orderPlace: null };
  }

  if (action.type === 'ORDER_REQUEST') {
    return { ...state, orderRequest: action.orderRequest };
  }

  if (action.type === 'CLEAR_ORDER_REQUEST') {
    return { ...state, orderRequest: null };
  }

  if (action.type === 'CLEAR_ORDER_TYPE') {
    return { ...state, orderType: null };
  }

  if (action.type === 'SET_APPLIED_OFFERS') {
    return { ...state, appliedOffer: action.appliedOffer };
  }

  if (action.type === 'CLEAR_APPLIED_OFFERS') {
    return { ...state, appliedOffer: null };
  }

  if (action.type === 'STORE_STATUS') {
    return { ...state, storeStatus: action.storeStatus };
  }

  if (action.type === 'STORE_OFFERS') {
    return { ...state, storeOffer: action.storeOffer };
  }

  if (action.type === 'SET_ENGINE_DISCOUNT') {
    return { ...state, engineDiscount: action.payload };
  }

  if (action.type === 'CLEAR_ENGINE_DISCOUNT') {
    return { ...state, engineDiscount: null };
  }

  if (action.type === SHOW_CART) {
    return state;
  }

  if (action.type === CLEAR_CART) {
    return {
      ...state,
      addedItems: [],
      total: 0,
      total_tax: 0,
      resultDis: 0,
      cgst: 0,
      sgst: 0,
      countCartItem: 0,
      child_store_id: null,
      offline_invoice_no: null,
      engineDiscount: null,
      appliedOffer: null,
      tip: 0,
    };
  }

  if (action.type === 'SYNC_CART_TOTALS') {
    return {
      ...state,
      subTotal: action.payload.sub_total ?? action.payload.total_item_price ?? state.subTotal,
      // Compute cart total = Item Total (base) + Tax — no round off
      total: (() => {
        const base = action.payload.sub_total ?? state.subTotal ?? 0;
        const tax  = action.payload.total_item_tax ?? state.total_tax ?? 0;
        const hasBase = action.payload.sub_total != null;
        return hasBase
          ? parseFloat((base + tax).toFixed(2))
          : (action.payload.transaction_grand_amount ?? state.total);
      })(),
      total_tax: action.payload.total_item_tax ?? state.total_tax,
      rounded_total: action.payload.rounded_total ?? action.payload.transaction_grand_amount ?? state.rounded_total,
      chargesTitle: action.payload.charges?.length ? action.payload.charges[0].title : state.chargesTitle,
      chargeValue: action.payload.charges?.length ? action.payload.charges[0].value : state.chargeValue,
      resultDis: action.payload.discount_amount ?? action.payload.resultDis ?? state.resultDis,
    };
  }

  if (action.type === WEB_LOGOUT) {
    return { ...initState };
  }

  else {
    return state;
  }
};

export default cartReducer;
